export const environment = {
    production: true,
    apiUrl: 'https://api.og.purple.lk/api',
    chargebeeSite: "easysalesops-test",
    recaptchaSiteKey: "6LcuWQMsAAAAAOf0UZJalCY6Wi9tU1YQtAAa5pUc",
};


  